import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Alert, Spinner } from 'react-bootstrap';
import { FaUser, FaLock } from 'react-icons/fa';
import { useAuth } from '../auth/AuthContext';
import LoginBackground from './LoginBackground';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated, initializing } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (!initializing && isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [initializing, isAuthenticated, navigate, from]);

  if (initializing) {
    return (
      <div className="login-page" style={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner animation="border" style={{ color: 'var(--brand)' }} />
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Ошибка входа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="login-page" style={{ position: 'relative', zIndex: 1 }}>
        <LoginBackground />
        <div className="login-card">
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Имя пользователя</Form.Label>
              <div className="login-input-wrapper">
                <FaUser className="login-input-icon" />
                <Form.Control
                  type="text"
                  placeholder="Введите логин"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoComplete="username"
                  className="login-input"
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Пароль</Form.Label>
              <div className="login-input-wrapper">
                <FaLock className="login-input-icon" />
                <Form.Control
                  type="password"
                  placeholder="Введите пароль"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                  className="login-input"
                />
              </div>
            </Form.Group>
            <button
              type="submit"
              className="app-btn app-btn-primary w-100"
              disabled={loading}
              style={{ justifyContent: 'center', textAlign: 'center' }}
            >
              {loading ? 'Вход...' : 'Войти'}
            </button>
          </Form>
        </div>
      </div>
    </>
  );
}

export default Login;